// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #98e3da;
    --primary-dark: #6fb8af;
    --bg: #f5f7fa;
    --text: #1f2933;
    --card-bg: #ffffff;
}

/* RESET */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

body, html, #root {
    height: 100%;
    background: var(--bg);
    color: var(--text);
}

/* LAYOUT */
.dashboard {
    display: flex;
    min-height: 100vh;
}

/* SIDEBAR */
.sidebar {
    width: 260px;
    background: var(--primary);
    color: #0b1f24;
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
}

.sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 32px;
}

.nav-section-title {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    opacity: 0.8;
    margin-bottom: 8px;
}

.nav {
    list-style: none;
    margin-bottom: 24px;
}

.nav li {
    margin-bottom: 6px;
}

.nav a {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    text-decoration: none;
    color: #0b1f24;
    font-size: 0.9rem;
    transition: background 0.2s, transform 0.1s;
    cursor: pointer;
}

.nav a:hover {
    background: rgba(255, 255, 255, 0.6);
    transform: translateX(2px);
}

.nav a.active {
    background: #ffffff;
    font-weight: 600;
}

.sidebar-footer {
    margin-top: auto;
    font-size: 0.8rem;
    opacity: 0.8;
}

.main {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

/* Form controls (inputs / textarea) consistent with site DA */
.form-input,
.form-textarea {
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #e3e7f0;
    background: var(--card-bg);
    color: var(--text);
    font-size: 0.95rem;
    outline: none;
    transition: box-shadow 0.12s ease, border-color 0.12s ease;
}

.form-input:focus,
.form-textarea:focus {
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
    border-color: rgba(111,184,175,0.9);
}

.form-textarea { min-height: 120px; resize: vertical; }

/* Chat admin input/button styles */
.chat-admin-input-row {
    display: flex;
    gap: 8px;
    padding: 8px;
    border-top: 1px solid rgba(0,0,0,0.06);
}
.chat-admin-input {
    flex: 1 1;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #e3e7f0;
    background: var(--card-bg, #fff);
    color: var(--text, #111);
    outline: none;
    transition: box-shadow 0.12s ease, border-color 0.12s ease;
}
.chat-admin-input:focus {
    box-shadow: 0 6px 18px rgba(15,23,42,0.06);
    border-color: rgba(11,132,255,0.9);
}
.chat-admin-btn {
    background: #007bff;
    color: #fff;
    border: none;
    padding: 8px 14px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: transform 0.08s ease, box-shadow 0.12s ease;
}
.chat-admin-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(0,0,0,0.08); }
.chat-admin-btn:disabled { opacity: 0.6; cursor: default; transform: none; box-shadow: none; }

/* Dark mode */
.dashboard.dark .chat-admin-input-row { border-top-color: rgba(255,255,255,0.06); }
.dashboard.dark .chat-admin-input { background: #0b1730; color: #e6eef6; border-color: rgba(255,255,255,0.08); }
.dashboard.dark .chat-admin-input::placeholder { color: rgba(230,238,246,0.6); }
.dashboard.dark .chat-admin-input:focus { box-shadow: 0 6px 18px rgba(11,132,255,0.12); border-color: rgba(11,132,255,0.9); }
.dashboard.dark .chat-admin-btn { background: #0b84ff; }

/* Chat admin action buttons */
.chat-btn {
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid transparent;
    background: transparent;
}
.chat-btn-ghost {
    background: transparent;
    color: var(--text, #111);
    border-color: rgba(0,0,0,0.06);
}
.chat-btn-ghost:hover { background: rgba(0,0,0,0.03); }
.chat-btn-danger {
    background: #dc3545;
    color: #fff;
    border-color: rgba(0,0,0,0.06);
}
.chat-btn-danger:hover { filter: brightness(0.95); transform: translateY(-1px); }
.chat-btn:disabled { opacity: 0.6; cursor: default; transform: none; }

/* Dark theme overrides */
.dashboard.dark .chat-btn-ghost { color: #e6eef6; border-color: rgba(255,255,255,0.04); }
.dashboard.dark .chat-btn-ghost:hover { background: rgba(255,255,255,0.02); }
.dashboard.dark .chat-btn-danger { background: #d14343; }

/* Dark mode variants for form controls */
.dashboard.dark .form-input,
.dashboard.dark .form-textarea {
    background: #0f1418; /* same as search input in dark */
    border: 1px solid #2a333a;
    color: var(--text);
}
.dashboard.dark .form-input:focus,
.dashboard.dark .form-textarea:focus {
    box-shadow: 0 6px 18px rgba(0,0,0,0.6);
    border-color: rgba(111,184,175,0.3);
}

/* Announce page: embed fields responsive row */
.embed-field-row {
    display: grid;
    grid-template-columns: 1fr 1fr 160px;
    gap: 8px;
    margin-top: 8px;
    align-items: start;
}

/* Button and checkbox group inside the last column */
.embed-field-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
}

@media (max-width: 900px) {
    .embed-field-row {
        grid-template-columns: 1fr;
    }
    .embed-field-actions {
        justify-content: flex-start;
    }
}

/* Themed color picker for Announce page */
.color-picker {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
}

.color-swatch {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid rgba(15,23,42,0.08);
    box-shadow: 0 4px 12px rgba(15,23,42,0.06);
    cursor: pointer;
}

.color-popover {
    position: absolute;
    top: 44px;
    left: 0;
    background: var(--card-bg);
    border: 1px solid #e3e7f0;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(15,23,42,0.12);
    z-index: 60;
    min-width: 260px;
}

.dashboard.dark .color-popover {
    background: #1a2228;
    border-color: #2a333a;
}

.color-presets {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 8px;
    margin-top: 8px;
}

.preset-swatch {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid rgba(15,23,42,0.06);
    cursor: pointer;
}

.native-color-input {
    width: 40px;
    height: 34px;
    padding: 0;
    border: none;
    background: transparent;
}

@media (max-width: 520px) {
    .color-popover { left: auto; right: 0; min-width: 220px; }
    .color-presets { grid-template-columns: repeat(6, 1fr); }
}

/* TOPBAR */
.topbar {
    width: 100%;
    height: 64px;
    background: #ffffff;
    border-bottom: 1px solid #e1e4ea;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    /*overflow: hidden;*/
}

.topbar-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.topbar-title {
    font-size: 1.1rem;
    font-weight: 600;
}

.search {
    padding: 8px 12px;
    border-radius: 999px;
    border: 1px solid #d0d7e2;
    font-size: 0.9rem;
    min-width: 220px;
    outline: none;
}

.topbar-right {
    display: flex;
    align-items: center;
    gap: 16px;
}

.badge {
    background: var(--primary);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 190px;
    color: #0b1f24;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 600;
}

.avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--primary-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 0.85rem;
    font-weight: 600;
}

.avatar:hover {
    opacity: 0.8;
}


/* CONTENT */
.content {
    padding: 24px;
    overflow-y: auto;
}

.cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

/* CARD */
.card {
    background: var(--card-bg);
    border-radius: 14px;
    padding: 16px 18px;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
    border: 1px solid #e3e7f0;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.card-title {
    font-size: 0.9rem;
    font-weight: 600;
    opacity: 0.8;
}

.card-value {
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 4px;
}

.card-sub {
    font-size: 0.8rem;
    opacity: 0.7;
}

.chip {
    font-size: 0.75rem;
    padding: 3px 8px;
    border-radius: 999px;
    background: rgba(152, 227, 218, 0.2);
    color: #0b1f24;
    font-weight: 500;
}

/* TABLE + CHART LAYOUT */
.layout-two-cols {
    display: grid;
    grid-template-columns: 2fr 1.2fr;
    gap: 20px;
}

/* TABLE */
.table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem;
}

.table thead {
    background: #f0f3f9;
}

.table th,
.table td {
    padding: 10px 8px;
    text-align: left;
    border-bottom: 1px solid #e3e7f0;
}

.table th {
    font-weight: 600;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    opacity: 0.8;
}

/* STATUS BADGES */
.status {
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 500;
}

.status-success {
    background: rgba(152, 227, 218, 0.2);
    color: #0b3b32;
}

.status-pending {
    background: #fff7e0;
    color: #8a5b00;
}

/* Announce preview styles (Discord-like) */
.announce-raw-message {
    white-space: pre-wrap;
    font-size: 0.95rem;
    padding: 0;
    margin: 0;
    background: transparent;
    border: none;
    color: inherit;
}
.dashboard.dark .announce-raw-message {
    background: transparent;
    border: none;
    color: #e6edf3;
}

.announce-embed {
    display: flex;
    border-radius: 10px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 6px 18px rgba(2,6,23,0.06);
    border: 1px solid #e6eef6;
}
.dashboard.dark .announce-embed {
    background: #202225;
    box-shadow: none;
    border-color: #2a2d30;
}

.announce-embed-colorbar {
    width: 8px;
}

.announce-embed-body {
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.announce-embed-author {
    display: flex;
    align-items: center;
    gap: 10px;
}
.announce-embed-author .avatar-sm {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #98e3da;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    color: #032018;
}
.announce-embed-title {
    font-weight: 700;
    font-size: 1rem;
    color: #0f172a;
}
.dashboard.dark .announce-embed-title { color: #ffffff; }

.announce-embed-description {
    color: #374151;
    font-size: 0.95rem;
    line-height: 1.35;
    white-space: pre-wrap;
}
.dashboard.dark .announce-embed-description { color: #cbd5e1; }

.announce-embed-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.announce-embed-field {
    background: #f8fafc;
    padding: 8px;
    border-radius: 6px;
    /* allow up to 3 inline fields per row */
    min-width: 120px;
    flex: 1 1 30%;
}
.announce-embed-field-name {
    font-size: 12px;
    font-weight: 700;
    color: #0f172a;
}
.announce-embed-field-value {
    margin-top: 6px;
    color: #334155;
    font-size: 13px;
    white-space: pre-wrap;
}
.dashboard.dark .announce-embed-field { background: #2b2d30; }
.dashboard.dark .announce-embed-field-name { color: #fff; }
.dashboard.dark .announce-embed-field-value { color: #cbd5e1; }

@media (max-width: 640px) {
    .announce-embed-field { flex: 1 1 100%; min-width: 100%; }
}


.status-cancelled {
    background: #ffe5e5;
    color: #8a1f1f;
}

/* CHART PLACEHOLDER */
.card-chart-placeholder {
    height: 220px;
    border-radius: 12px;
    background: repeating-linear-gradient(
            -45deg,
            #f3f6fb,
            #f3f6fb 8px,
            #e4ebf7 8px,
            #e4ebf7 16px
    );
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
    color: #6b7280;
}

.dark {
    --bg: #0f1418;
    --text: #e5e9ec;
    --card-bg: #1a2228;
    --primary: #98e3da;
    --primary-dark: #6fb8af;
}

.dark body,
.dashboard.dark {
    background: var(--bg);
    color: var(--text);
}

.dashboard.dark .sidebar {
    background: #132025;
    color: var(--text);
}

.dashboard.dark .nav a {
    color: var(--text);
}

.dashboard.dark .nav a:hover {
    background: rgba(255, 255, 255, 0.1);
}

.dashboard.dark .nav a.active {
    background: rgba(255, 255, 255, 0.15);
}

.dashboard.dark .topbar {
    background: #1a2228;
    border-bottom: 1px solid #2a333a;
}

.dashboard.dark .search {
    background: #0f1418;
    border: 1px solid #2a333a;
    color: var(--text);
}

.dashboard.dark .card {
    background: var(--card-bg);
    border: 1px solid #2a333a;
}

.dashboard.dark .table thead {
    background: #222c33;
}

.dashboard.dark .table td,
.dashboard.dark .table th {
    border-bottom: 1px solid #2a333a;
}

.dashboard.dark .card-chart-placeholder {
    background: repeating-linear-gradient(
            -45deg,
            #1f2a30,
            #1f2a30 8px,
            #25333a 8px,
            #25333a 16px
    );
    color: #9aa5ac;
}

.dashboard.dark .status-success {
    background: rgba(152, 227, 218, 0.15);
    color: #98e3da;
}

.dashboard.dark .status-pending {
    background: rgba(255, 200, 100, 0.15);
    color: #ffcc66;
}

.dashboard.dark .status-cancelled {
    background: rgba(255, 120, 120, 0.15);
    color: #ff8a8a;
}

.theme-toggle {
    background: transparent;
    border: 1px solid #d0d7e2;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    transition: 0.2s;
}

.theme-toggle:hover {
    background: rgba(0, 0, 0, 0.05);
}

/* Dark mode */
.dashboard.dark .theme-toggle {
    border-color: #2a333a;
    color: #e5e9ec;
}

/* Styled tooltip used in small tables (Activité récente) */
.cell-with-tooltip {
    position: relative;
    display: inline-block;
    cursor: default;
    outline: none;
}

.cell-with-tooltip:focus {
    /* subtle focus ring for keyboard users */
    box-shadow: 0 0 0 4px rgba(152,227,218,0.18);
    border-radius: 6px;
}

.cell-with-tooltip .tooltip {
    pointer-events: none;
    position: absolute;
    left: 0;
    bottom: calc(100% + 8px);
    transform-origin: left bottom;
    background: #0b1f24;
    color: #fff;
    padding: 8px 10px;
    border-radius: 8px;
    font-size: 0.85rem;
    line-height: 1.2;
    max-width: 320px;
    white-space: normal;
    box-shadow: 0 6px 18px rgba(15,23,42,0.2);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.12s ease, transform 0.12s ease, visibility 0.12s;
    z-index: 50;
}

.cell-with-tooltip .tooltip::after {
    content: '';
    position: absolute;
    left: 12px;
    top: 100%;
    width: 8px;
    height: 8px;
    background: inherit;
    transform: rotate(45deg);
}

.cell-with-tooltip:hover .tooltip,
.cell-with-tooltip:focus .tooltip,
.cell-with-tooltip:focus-within .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(0) scale(1);
}

/* Dark mode tooltip tweaks */
.dashboard.dark .cell-with-tooltip .tooltip {
    background: #111a1d;
    color: #e5e9ec;
}

/* Presence badge like Discord */
.presence-badge {
    display: none; /* badge now integrated into the pill-style label */
}

/* Clean pill-style presence label */
.presence-label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    border-radius: 999px;
    font-weight: 600;
    font-size: 0.85rem;
    line-height: 1;
    text-transform: none;
    box-shadow: none;
    transition: background-color 0.12s ease, color 0.12s ease, transform 0.08s ease;
}

.presence-label::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 6px;
}

.presence-label.presence-online { color: #0b4f41; background: rgba(67,181,129,0.12); }
.presence-label.presence-online::before { background: #43b581; }

.presence-label.presence-idle { color: #6b4a10; background: rgba(250,166,26,0.08); }
.presence-label.presence-idle::before { background: #faa61a; }

.presence-label.presence-dnd { color: #7a2b2b; background: rgba(240,71,71,0.08); }
.presence-label.presence-dnd::before { background: #f04747; }

.presence-label.presence-offline { color: #39424a; background: rgba(116,127,141,0.06); }
.presence-label.presence-offline::before { background: #747f8d; }

.presence-label:hover { transform: translateY(-1px); }

.dashboard.dark .presence-label.presence-online {
    background: rgba(67,181,129,0.12);
    color: #dbf7ee; /* lighter text for contrast */
    border: 1px solid rgba(67,181,129,0.06);
}
.dashboard.dark .presence-label.presence-online::before {
    background: #43b581;
    box-shadow: 0 0 8px rgba(67,181,129,0.12);
}

.dashboard.dark .presence-label.presence-idle {
    background: rgba(250,166,26,0.10);
    color: #ffeecd; /* warm light text */
    border: 1px solid rgba(250,166,26,0.06);
}
.dashboard.dark .presence-label.presence-idle::before {
    background: #faa61a;
    box-shadow: 0 0 6px rgba(250,166,26,0.08);
}

.dashboard.dark .presence-label.presence-dnd {
    background: rgba(240,71,71,0.10);
    color: #ffd6d6; /* soft light red */
    border: 1px solid rgba(240,71,71,0.06);
}
.dashboard.dark .presence-label.presence-dnd::before {
    background: #f04747;
    box-shadow: 0 0 6px rgba(240,71,71,0.08);
}

.dashboard.dark .presence-label.presence-offline {
    background: rgba(116,127,141,0.06);
    color: #cbd5dd; /* neutral light */
    border: 1px solid rgba(255,255,255,0.02);
}
.dashboard.dark .presence-label.presence-offline::before {
    background: #9aa5ac;
}

.dashboard.dark .theme-toggle:hover {
    background: rgba(255, 255, 255, 0.1);
}

/* Avatar wrapper */
.avatar-wrapper {
    position: relative;
}

/* Menu utilisateur */
.user-menu {
    position: absolute;
    top: 40px;
    right: 0;
    background: var(--card-bg);
    /*border: 1px solid #e3e7f0;*/
    border: 1px solid #cfd6dd;
    border-radius: 10px;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
    padding: 8px 0;
    width: 160px;
    z-index: 20;
    display: flex;
    flex-direction: column;
}

/* Petite flèche du menu utilisateur */
/* Flèche du menu utilisateur */
.user-menu::before {
    content: "";
    position: absolute;
    top: -12px;
    right: 18px;
    width: 0;
    height: 0;

    /* Flèche visible */
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 12px solid var(--card-bg);

    /* Bordure autour de la flèche */
    z-index: -1;
}

.user-menu::after {
    content: "";
    position: absolute;
    top: -14px;
    right: 18px;
    width: 0;
    height: 0;

    /* Bordure de la flèche */
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 13px solid #cfd6dd; /* bordure claire */
}

/* Version Dark Mode */
.dark .user-menu::after {
    border-bottom-color: #2a333a; /* bordure foncée */
}

.dark .user-menu::before {
    border-bottom-color: #1a2228; /* couleur du menu dark */
}



.user-menu button {
    background: none;
    border: none;
    padding: 10px 14px;
    text-align: left;
    width: 100%;
    font-size: 0.9rem;
    cursor: pointer;
    color: var(--text);
}

.user-menu button:hover {
    background: rgba(0, 0, 0, 0.05);
}

/* Dark mode */
.dark .user-menu {
    background: #1a2228;
    border-color: #2a333a;
}

.dark .user-menu button:hover {
    background: rgba(255, 255, 255, 0.1);
}

.avatar {
    cursor: pointer;
}

.user-menu button {
    cursor: pointer;
}

/* Animation fade + slide */
@keyframes fadeSlideIn {
    0% {
        opacity: 0;
        transform: translateY(-6px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Appliquer l’animation au menu */
.user-menu {
    animation: fadeSlideIn 0.18s ease-out;
}

@keyframes fadeSlideOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }
    100% {
        opacity: 0;
        transform: translateY(-6px);
    }
}

.user-menu.closing {
    animation: fadeSlideOut 0.15s ease-in forwards;
}

/* Groupe des statuts serveurs */
.server-status-group {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 20px;
}

.server-status {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    opacity: 0.9;
}

.status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.status-dot.online {
    background: #4caf50;
}

.status-dot.offline {
    background: #e53935;
}

.dark .server-status {
    color: #e5e9ec;
}

/* Followmaj icon in Requests table */
.followmaj {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 20px;
    border-radius: 6px;
    font-weight: 700;
}
.followmaj.true { color: #10b981; background: rgba(16,185,129,0.06); border: 1px solid rgba(16,185,129,0.08); }
.followmaj.false { color: #ef4444; background: rgba(239,68,68,0.06); border: 1px solid rgba(239,68,68,0.06); }
.dashboard.dark .followmaj.true { background: rgba(16,185,129,0.10); }
.dashboard.dark .followmaj.false { background: rgba(239,68,68,0.10); }

/* center specific table columns */
.table th.center-col,
.table td.center-col {
    text-align: center;
    vertical-align: middle;
    /* Prevent header/cell text from wrapping (keep labels like "Suivi MAJ" on one line) */
    white-space: nowrap;
}

/* narrower user column for Requests table */
.table .col-user {
    /* revert to default flow so user names aren't truncated */
    width: auto;
    max-width: none;
    white-space: normal;
    overflow: visible;
}
.table .col-user strong {
    display: inline-block;
    max-width: none;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
}

/* Suivi MAJ column: keep it wide enough to avoid wrapping */
.table th.center-col {
    min-width: 96px; /* increased so "Suivi MAJ" doesn't wrap */
    width: auto;
    white-space: nowrap;
}

/* Animation pulsante façon Discord */
@keyframes pulseOnline {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.6);
    }
    70% {
        transform: scale(1.15);
        box-shadow: 0 0 10px 6px rgba(76, 175, 80, 0);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
    }
}

/* Appliquer l’animation au rond vert */
.status-dot.online {
    background: #4caf50;
    animation: pulseOnline 1.8s infinite ease-out;
}

/* Animation clignotante rouge (erreur critique) */
@keyframes blinkOffline {
    0% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.35;
        transform: scale(0.85);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

/* Appliquer l’animation au rond rouge */
.status-dot.offline {
    background: #e53935;
    animation: blinkOffline 1.4s infinite ease-in-out;
}

/* Tooltip général */
.server-status {
    position: relative;
}

/* Bulle du tooltip (désormais en dessous) */
.server-status:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    top: 26px; /* en dessous du rond */
    left: 50%;
    transform: translateX(-50%);
    background: var(--card-bg);
    color: var(--text);
    padding: 6px 10px;
    font-size: 0.75rem;
    border-radius: 6px;
    white-space: nowrap;
    border: 1px solid #cfd6dd;
    opacity: 0;
    animation: tooltipFadeDown 0.18s forwards ease-out;
    pointer-events: none;
    z-index: 50;
}

/* Petite flèche (vers le haut cette fois) */
.server-status:hover::before {
    content: "";
    position: absolute;
    top: 18px; /* juste sous le rond */
    left: 50%;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid var(--card-bg);
    opacity: 0;
    animation: tooltipFadeDown 0.18s forwards ease-out;
    z-index: 49;
}

/* Animation fade + slide vers le bas */
@keyframes tooltipFadeDown {
    0% {
        opacity: 0;
        transform: translate(-50%, -4px);
    }
    100% {
        opacity: 1;
        transform: translate(-50%, 0);
    }
}

/* Dark mode */
.dark .server-status:hover::after {
    background: #1a2228;
    border-color: #2a333a;
    color: #e5e9ec;
}

.dark .server-status:hover::before {
    border-top-color: #1a2228;
}

/*.notif-wrapper {*/
/*    position: relative;*/
/*}*/

/*.notif-bell {*/
/*    position: relative;*/
/*    font-size: 1.3rem;*/
/*    cursor: pointer;*/
/*    margin-right: 14px;*/
/*}*/

/*.notif-badge {*/
/*    position: absolute;*/
/*    top: -4px;*/
/*    right: -6px;*/
/*    background: #e53935;*/
/*    color: white;*/
/*    font-size: 0.65rem;*/
/*    padding: 2px 5px;*/
/*    border-radius: 50%;*/
/*}*/

/*@keyframes shakeBell {*/
/*    0% { transform: rotate(0deg); }*/
/*    20% { transform: rotate(-15deg); }*/
/*    40% { transform: rotate(15deg); }*/
/*    60% { transform: rotate(-10deg); }*/
/*    80% { transform: rotate(10deg); }*/
/*    100% { transform: rotate(0deg); }*/
/*}*/

/*.notif-bell.shake {*/
/*    animation: shakeBell 0.6s ease;*/
/*}*/

/*.notif-menu {*/
/*    position: absolute;*/
/*    top: 36px;*/
/*    right: 0;*/
/*    background: var(--card-bg);*/
/*    border: 1px solid #cfd6dd;*/
/*    border-radius: 10px;*/
/*    width: 240px;*/
/*    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);*/
/*    padding: 8px 0;*/
/*    animation: fadeSlideIn 0.18s ease-out;*/
/*    z-index: 30;*/
/*}*/

/*.notif-item {*/
/*    padding: 10px 14px;*/
/*    font-size: 0.85rem;*/
/*    border-bottom: 1px solid rgba(0,0,0,0.05);*/
/*}*/

/*.notif-item:last-child {*/
/*    border-bottom: none;*/
/*}*/

/*!* Couleurs selon type *!*/
/*.notif-item.info { color: #1976d2; }*/
/*.notif-item.success { color: #2e7d32; }*/
/*.notif-item.error { color: #d32f2f; }*/

/*.dark .notif-menu {*/
/*    background: #1a2228;*/
/*    border-color: #2a333a;*/
/*}*/

/*.dark .notif-item {*/
/*    border-bottom-color: rgba(255,255,255,0.08);*/
/*}*/

/*!* Flèche du menu notifications *!*/
/*.notif-menu::before {*/
/*    content: "";*/
/*    position: absolute;*/
/*    top: -10px;*/
/*    right: 14px;*/
/*    width: 0;*/
/*    height: 0;*/

/*    border-left: 8px solid transparent;*/
/*    border-right: 8px solid transparent;*/
/*    border-bottom: 10px solid var(--card-bg);*/
/*}*/

/*!* Bordure de la flèche *!*/
/*.notif-menu::after {*/
/*    content: "";*/
/*    position: absolute;*/
/*    top: -12px;*/
/*    right: 13px;*/

/*    border-left: 9px solid transparent;*/
/*    border-right: 9px solid transparent;*/
/*    border-bottom: 12px solid #cfd6dd;*/
/*}*/

/*.dark .notif-menu::before {*/
/*    border-bottom-color: #1a2228;*/
/*}*/

/*.dark .notif-menu::after {*/
/*    border-bottom-color: #2a333a;*/
/*}*/

/*.notif-menu {*/
/*    animation: fadeSlideIn 0.18s ease-out;*/
/*}*/

/*.notif-menu.closing {*/
/*    animation: fadeSlideOut 0.15s ease-in forwards;*/
/*}*/

/*!* Icône dans chaque notification *!*/
/*.notif-icon {*/
/*    margin-right: 8px;*/
/*    font-size: 1rem;*/
/*}*/

/*!* Styles par catégorie *!*/
/*.notif-item.info {*/
/*    color: #1976d2;*/
/*    background: rgba(25, 118, 210, 0.08);*/
/*}*/

/*.notif-item.warning {*/
/*    color: #f9a825;*/
/*    background: rgba(249, 168, 37, 0.12);*/
/*}*/

/*.notif-item.error {*/
/*    color: #d32f2f;*/
/*    background: rgba(211, 47, 47, 0.12);*/
/*}*/

/*!* Hover *!*/
/*.notif-item:hover {*/
/*    background: rgba(0,0,0,0.06);*/
/*}*/

/*.dark .notif-item:hover {*/
/*    background: rgba(255,255,255,0.06);*/
/*}*/

/*!* Dark mode *!*/
/*.dark .notif-item.info {*/
/*    background: rgba(25, 118, 210, 0.18);*/
/*}*/

/*.dark .notif-item.warning {*/
/*    background: rgba(249, 168, 37, 0.18);*/
/*}*/

/*.dark .notif-item.error {*/
/*    background: rgba(211, 47, 47, 0.18);*/
/*}*/

/* ===========================
   WRAPPER & BELL
=========================== */
.notif-wrapper {
    position: relative;
}

.notif-bell {
    position: relative;
    font-size: 1.4rem;
    cursor: pointer;
    margin-right: 14px;
    transition: transform 0.15s ease;
}

.notif-bell:hover {
    transform: scale(1.1);
}

/* Badge rouge sur la cloche */
.notif-badge {
    position: absolute;
    top: -4px;
    right: -6px;
    background: #ef4444;
    color: white;
    font-size: 0.65rem;
    padding: 2px 6px;
    border-radius: 999px;
    font-weight: 600;
    box-shadow: 0 0 4px rgba(0,0,0,0.2);
}

/* Animation cloche */
@keyframes shakeBell {
    0% { transform: rotate(0deg); }
    20% { transform: rotate(-15deg); }
    40% { transform: rotate(15deg); }
    60% { transform: rotate(-10deg); }
    80% { transform: rotate(10deg); }
    100% { transform: rotate(0deg); }
}

.notif-bell.shake {
    animation: shakeBell 0.6s ease;
}

/* ===========================
   MENU
=========================== */
.notif-menu {
    position: absolute;
    top: 38px;
    right: 0;
    width: 260px;
    background: var(--card-bg);
    border-radius: 12px;
    padding: 6px 0;
    box-shadow: 0 12px 28px rgba(0,0,0,0.12);
    border: 1px solid rgba(0,0,0,0.08);
    animation: notifSlideIn 0.18s ease-out;
    overflow: hidden;
    z-index: 50;
}

/* Animation ouverture */
@keyframes notifSlideIn {
    from {
        opacity: 0;
        transform: translateY(-6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Animation fermeture */
.notif-menu.closing {
    animation: notifSlideOut 0.15s ease-in forwards;
}

@keyframes notifSlideOut {
    from {
        opacity: 1;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        transform: translateY(-6px);
    }
}

/* Flèche */
.notif-menu::before {
    content: "";
    position: absolute;
    top: -8px;
    right: 16px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 8px solid var(--card-bg);
}

.notif-menu::after {
    content: "";
    position: absolute;
    top: -10px;
    right: 15px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 10px solid rgba(0,0,0,0.08);
}

/* ===========================
   ITEMS
=========================== */
.notif-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    font-size: 0.85rem;
    border-bottom: 1px solid rgba(0,0,0,0.05);
    background: transparent;
    transition: background 0.15s ease;
}

.notif-item:last-child {
    border-bottom: none;
}

.notif-item:hover {
    background: rgba(0,0,0,0.04);
}

/* Texte */
.notif-text {
    flex: 1 1;
    color: var(--text-color);
}

/* ===========================
   BADGES
=========================== */
.notif-badge-type {
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: white;
    flex-shrink: 0;
}

/* Variants */
.notif-item.maj .notif-badge-type {
    background: #2ec0ca;
}

.notif-item.user .notif-badge-type {
    background: rgba(230, 14, 201, 0.8);
}

.notif-item.info .notif-badge-type {
    background: #1976d2;
}

.notif-item.warning .notif-badge-type {
    background: #f9a825;
}

.notif-item.error .notif-badge-type {
    background: #d32f2f;
}

.notif-item.new .notif-badge-type {
    background: #2fd332;
}

/* ===========================
   DARK MODE
=========================== */
.dark .notif-menu {
    background: #1e262c;
    border-color: #2a333a;
}

.dark .notif-item {
    border-bottom-color: rgba(255,255,255,0.06);
}

.dark .notif-item:hover {
    background: rgba(255,255,255,0.06);
}

.dark .notif-text {
    color: #e5e7eb;
}

.dark .notif-item.maj .notif-badge-type {
    background: rgba(19, 183, 212, 0.8);
}

.dark .notif-item.user .notif-badge-type {
    background: rgba(199, 12, 174, 0.8);
}

.dark .notif-item.info .notif-badge-type {
    background: rgba(25,118,210,0.8);
}

.dark .notif-item.warning .notif-badge-type {
    background: rgba(249,168,37,0.8);
}

.dark .notif-item.error .notif-badge-type {
    background: rgba(211,47,47,0.8);
}

.dark .notif-item.new .notif-badge-type {
    background: rgba(47, 211, 50, 0.8);
}


.notif-item.read {
    opacity: 0.55;
}

.notif-item.read .notif-badge-type {
    filter: grayscale(1);
    opacity: 0.6;
}

.notif-item.read .notif-text {
    color: #9ca3af;
}


/* FIN NOTIF */

.admin-badge {
    background: #d32f2f;
    color: white;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    margin-left: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Badge pour les modérateurs */
.moderator-badge {
    background: #f9a825; /* blue-600 */
    color: white;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    margin-left: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.dashboard.dark .moderator-badge {
    background: #f9a825; /* blue-800 for dark mode */
    color: #e6edf3;
    border: 1px solid rgba(255,255,255,0.04);
}

.sidebar-overlay {
    display: none;
}

.sidebar-close-btn {
    display: none;
    background: none;
    border: none;
    font-size: 22px;
    cursor: pointer;
    margin-left: auto;
}

.astuce-card {
    padding: 20px;
    font-size: 1rem;
    line-height: 1.5;
    /*color: #333;*/
    position: relative;
    /*background: #fff8f5;*/
    border-left: 4px solid #6fb8af;
    border-radius: 0 0 14px 14px;
    height: 250px;
    overflow-y: auto;
}

/* Icône décorative en fond */
.astuce-card::before {
    content: "🍅";
    position: absolute;
    font-size: 70px;
    opacity: 0.15;
    right: 20px;
    bottom: 10px;
    pointer-events: none;
}

/* Animation d’apparition du texte */
.astuce-card p {
    animation: fadeIn 0.4s ease forwards;
    opacity: 0;
}

.info-card {
    padding: 20px;
    font-size: 1rem;
    line-height: 1.5;
    /*color: #333;*/
    position: relative;
    /*background: #fff8f5;*/
    border-left: 4px solid #6fb8af;
    border-radius: 0 0 14px 14px;
    height: 250px;
    overflow-y: auto;
}

/* Icône décorative en fond */
.info-card::before {
    content: "💻";
    position: absolute;
    font-size: 70px;
    opacity: 0.15;
    right: 20px;
    bottom: 10px;
    pointer-events: none;
}

/* Animation d’apparition du texte */
.info-card p {
    animation: fadeIn 0.4s ease forwards;
    opacity: 0;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
}

/* --- Bouton Refresh --- */

.refresh-btn {
    padding: 6px 12px;
    background: #6fb8af;
    color: white;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s ease;
}

.refresh-btn:hover {
    background: #5aa79e;
}

.refresh-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Dark mode */
.dashboard.dark .refresh-btn {
    background: #6fb8af;
    color: #0a1929;
}

.dashboard.dark .refresh-btn:hover {
    background: #5aa79e;
}

.pagination-controls {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);

    display: flex;
    align-items: center;
    gap: 15px;
}

.pagination-controls button {
    width: 35px;
    height: 35px;

    border: none;
    border-radius: 50%;

    background: rgba(104, 211, 206, 0.2);
    color: #68d3ce;

    cursor: pointer;
    transition: 0.3s;
}

.pagination-controls button:hover {
    background: #68d3ce;
    color: #111;
}

.pagination-controls span {
    color: #fff;
    font-size: 14px;
}

.pagination-dots {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(255,255,255,0.3);
    cursor: pointer;
    transition: 0.3s;
}

.dot.active {
    background: #68d3ce;
    transform: scale(1.2);
}

.info-content {
    animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(15px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.pagination-container {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);

    width: 200px;

    display: flex;
    flex-direction: column;
    gap: 8px;
}

.progress-bar {
    width: 100%;
    height: 4px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
    overflow: hidden;
}

.progress-fill {
    height: 100%;
    background: #68d3ce;
    border-radius: 10px;

    animation: progressAnimation 10s linear forwards;
}

@keyframes progressAnimation {
    from {
        width: 0%;
    }

    to {
        width: 100%;
    }
}

.segments {
    display: flex;
    gap: 4px;
    width: 100%;
}

.segment {
    display: flex;
    gap: 6px;
    width: 100%;
    height: 6px;
    background: rgba(255,255,255,.15);
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
}

.segment.completed {
    background: #68d3ce;
}

.segment-progress {
    height: 100%;
    background: linear-gradient(
            90deg,
            #68d3ce,
            #8ef5f0
    );
}

.timer-display {
    margin-top: 6px;

    text-align: center;
    font-size: 12px;

    color: rgba(255,255,255,0.6);
}

.announcement-footer {
    position: absolute;
    bottom: 0;
    left: 0;

    width: 100%;
    padding: 0 20px 10px;
    box-sizing: border-box;
}


/* Tablette */
@media (max-width: 1024px) {
    .cards {
        grid-template-columns: repeat(2, 1fr);
    }
    .layout-two-cols {
        grid-template-columns: 1fr;
    }
}
.menu-btn {
    display: none;
    font-size: 26px;
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 12px;
}


/* Mobile */
@media (max-width: 768px) {
    .menu-btn {
        display: block;
    }
    .dashboard {
        flex-direction: column;
    }
    .content {
        padding: 12px;
    }
    .cards {
        grid-template-columns: 1fr;
        gap: 12px;
    }
    .layout-two-cols {
        gap: 12px;
        margin-top: 20px;
    }
    .sidebar {
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        transition: transform 0.3s ease;
        z-index: 200;
        transform: translateX(-100%);
    }
    .sidebar.open {
        transform: translateX(0);
    }
    .server-status-group {
        display: none;
    }
    .topbar {
        padding: 12px 16px;
        flex-direction: column;
        align-items: stretch;
        flex-wrap: wrap;
    }
    .topbar-left {
        flex-wrap: wrap;
        min-width: 0
    }
    .topbar-right {
        display: none;
    }

    .search {
        flex: none;
        min-width: 120px;
    }

    .server-status-group,
    .session-container,
    .notif-wrapper,
    .avatar-wrapper {
        min-width: 0;
        flex-shrink: 1; /* autorise la compression */
    }

    .badge {
        white-space: nowrap; /* évite les retours moches */
        font-size: 14px;
    }
    .sidebar-close-btn {
        display: block;
        background: none;
        border: none;
        font-size: 22px;
        cursor: pointer;
        color: #0b1f24;
    }

}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA,UAAU;AACV;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,iFAAiF;AACrF;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,YAAY;IACZ,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA,8DAA8D;AAC9D;;IAEI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,0DAA0D;AAC9D;;AAEA;;IAEI,6CAA6C;IAC7C,mCAAmC;AACvC;;AAEA,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE;;AAEtD,mCAAmC;AACnC;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,sCAAsC;AAC1C;AACA;IACI,SAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,wBAAwB;IACxB,aAAa;IACb,0DAA0D;AAC9D;AACA;IACI,0CAA0C;IAC1C,kCAAkC;AACtC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uDAAuD;AAC3D;AACA,wBAAwB,2BAA2B,EAAE,uCAAuC,EAAE;AAC9F,2BAA2B,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE7F,cAAc;AACd,wCAAwC,wCAAwC,EAAE;AAClF,oCAAoC,mBAAmB,EAAE,cAAc,EAAE,oCAAoC,EAAE;AAC/G,iDAAiD,4BAA4B,EAAE;AAC/E,0CAA0C,4CAA4C,EAAE,kCAAkC,EAAE;AAC5H,kCAAkC,mBAAmB,EAAE;;AAEvD,8BAA8B;AAC9B;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;AAClC;AACA,wBAAwB,4BAA4B,EAAE;AACtD;IACI,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;AACA,yBAAyB,wBAAwB,EAAE,2BAA2B,EAAE;AAChF,qBAAqB,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE;;AAErE,yBAAyB;AACzB,kCAAkC,cAAc,EAAE,oCAAoC,EAAE;AACxF,wCAAwC,kCAAkC,EAAE;AAC5E,mCAAmC,mBAAmB,EAAE;;AAExD,yCAAyC;AACzC;;IAEI,mBAAmB,EAAE,iCAAiC;IACtD,yBAAyB;IACzB,kBAAkB;AACtB;AACA;;IAEI,sCAAsC;IACtC,mCAAmC;AACvC;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,oCAAoC;IACpC,QAAQ;IACR,eAAe;IACf,kBAAkB;AACtB;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB,UAAU,EAAE,QAAQ,EAAE,gBAAgB,EAAE;IACzD,iBAAiB,qCAAqC,EAAE;AAC5D;;AAEA,WAAW;AACX;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;;AAGA,YAAY;AACZ;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA,SAAS;AACT;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,oCAAoC;IACpC,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;;AAEA,UAAU;AACV;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,2CAA2C;AAC3C;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA,wCAAwC,cAAc,EAAE;;AAExD;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;AACA,8CAA8C,cAAc,EAAE;;AAE9D;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;AACA,wCAAwC,mBAAmB,EAAE;AAC7D,6CAA6C,WAAW,EAAE;AAC1D,8CAA8C,cAAc,EAAE;;AAE9D;IACI,wBAAwB,cAAc,EAAE,eAAe,EAAE;AAC7D;;;AAGA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB;;;;;;KAMC;IACD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI;;;;;;KAMC;IACD,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,cAAc;AACd;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA,2DAA2D;AAC3D;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,OAAO;IACP,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;IACV,kBAAkB;IAClB,sEAAsE;IACtE,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;;;IAGI,UAAU;IACV,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA,6BAA6B;AAC7B;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,aAAa,EAAE,mDAAmD;AACtE;;AAEA,oCAAoC;AACpC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,+EAA+E;AACnF;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,kCAAkC,cAAc,EAAE,iCAAiC,EAAE;AACrF,0CAA0C,mBAAmB,EAAE;;AAE/D,gCAAgC,cAAc,EAAE,iCAAiC,EAAE;AACnF,wCAAwC,mBAAmB,EAAE;;AAE7D,+BAA+B,cAAc,EAAE,gCAAgC,EAAE;AACjF,uCAAuC,mBAAmB,EAAE;;AAE5D,mCAAmC,cAAc,EAAE,kCAAkC,EAAE;AACvF,2CAA2C,mBAAmB,EAAE;;AAEhE,wBAAwB,2BAA2B,EAAE;;AAErD;IACI,iCAAiC;IACjC,cAAc,EAAE,8BAA8B;IAC9C,uCAAuC;AAC3C;AACA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;IACjC,cAAc,EAAE,oBAAoB;IACpC,uCAAuC;AAC3C;AACA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;IAChC,cAAc,EAAE,mBAAmB;IACnC,sCAAsC;AAC1C;AACA;IACI,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,cAAc,EAAE,kBAAkB;IAClC,wCAAwC;AAC5C;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,cAAc;IACd,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA,sCAAsC;AACtC,+BAA+B;AAC/B;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,SAAS;;IAET,mBAAmB;IACnB,kCAAkC;IAClC,mCAAmC;IACnC,wCAAwC;;IAExC,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,SAAS;;IAET,yBAAyB;IACzB,kCAAkC;IAClC,mCAAmC;IACnC,iCAAiC,EAAE,mBAAmB;AAC1D;;AAEA,sBAAsB;AACtB;IACI,4BAA4B,EAAE,mBAAmB;AACrD;;AAEA;IACI,4BAA4B,EAAE,yBAAyB;AAC3D;;;;AAIA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,kCAAkC;AAClC;IACI,qCAAqC;AACzC;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,2BAA2B;IAC/B;AACJ;;AAEA;IACI,8CAA8C;AAClD;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,qCAAqC;AACrC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA,kBAAkB,cAAc,EAAE,iCAAiC,EAAE,uCAAuC,EAAE;AAC9G,mBAAmB,cAAc,EAAE,gCAAgC,EAAE,sCAAsC,EAAE;AAC7G,kCAAkC,iCAAiC,EAAE;AACrE,mCAAmC,gCAAgC,EAAE;;AAErE,kCAAkC;AAClC;;IAEI,kBAAkB;IAClB,sBAAsB;IACtB,sFAAsF;IACtF,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;IACI,0DAA0D;IAC1D,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA,4DAA4D;AAC5D;IACI,eAAe,EAAE,0CAA0C;IAC3D,WAAW;IACX,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI;QACI,mBAAmB;QACnB,0CAA0C;IAC9C;IACA;QACI,sBAAsB;QACtB,6CAA6C;IACjD;IACA;QACI,mBAAmB;QACnB,wCAAwC;IAC5C;AACJ;;AAEA,uCAAuC;AACvC;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA,kDAAkD;AAClD;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,wCAAwC;AACxC;IACI,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;AACtB;;AAEA,4CAA4C;AAC5C;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS,EAAE,uBAAuB;IAClC,SAAS;IACT,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,kDAAkD;IAClD,oBAAoB;IACpB,WAAW;AACf;;AAEA,4CAA4C;AAC5C;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS,EAAE,uBAAuB;IAClC,SAAS;IACT,2BAA2B;IAC3B,kCAAkC;IAClC,mCAAmC;IACnC,oCAAoC;IACpC,UAAU;IACV,kDAAkD;IAClD,WAAW;AACf;;AAEA,uCAAuC;AACvC;IACI;QACI,UAAU;QACV,gCAAgC;IACpC;IACA;QACI,UAAU;QACV,6BAA6B;IACjC;AACJ;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB,0BAA0B;AAC1B,IAAI;;AAEJ,gBAAgB;AAChB,0BAA0B;AAC1B,yBAAyB;AACzB,uBAAuB;AACvB,0BAA0B;AAC1B,IAAI;;AAEJ,iBAAiB;AACjB,0BAA0B;AAC1B,iBAAiB;AACjB,mBAAmB;AACnB,2BAA2B;AAC3B,oBAAoB;AACpB,0BAA0B;AAC1B,wBAAwB;AACxB,0BAA0B;AAC1B,IAAI;;AAEJ,yBAAyB;AACzB,sCAAsC;AACtC,yCAAyC;AACzC,wCAAwC;AACxC,yCAAyC;AACzC,wCAAwC;AACxC,wCAAwC;AACxC,IAAI;;AAEJ,sBAAsB;AACtB,sCAAsC;AACtC,IAAI;;AAEJ,gBAAgB;AAChB,0BAA0B;AAC1B,iBAAiB;AACjB,gBAAgB;AAChB,kCAAkC;AAClC,iCAAiC;AACjC,2BAA2B;AAC3B,oBAAoB;AACpB,qDAAqD;AACrD,sBAAsB;AACtB,6CAA6C;AAC7C,mBAAmB;AACnB,IAAI;;AAEJ,gBAAgB;AAChB,0BAA0B;AAC1B,0BAA0B;AAC1B,iDAAiD;AACjD,IAAI;;AAEJ,2BAA2B;AAC3B,2BAA2B;AAC3B,IAAI;;AAEJ,4BAA4B;AAC5B,uCAAuC;AACvC,0CAA0C;AAC1C,wCAAwC;;AAExC,sBAAsB;AACtB,2BAA2B;AAC3B,6BAA6B;AAC7B,IAAI;;AAEJ,sBAAsB;AACtB,mDAAmD;AACnD,IAAI;;AAEJ,qCAAqC;AACrC,wBAAwB;AACxB,mBAAmB;AACnB,0BAA0B;AAC1B,kBAAkB;AAClB,mBAAmB;AACnB,gBAAgB;AAChB,iBAAiB;;AAEjB,0CAA0C;AAC1C,2CAA2C;AAC3C,gDAAgD;AAChD,IAAI;;AAEJ,6BAA6B;AAC7B,uBAAuB;AACvB,mBAAmB;AACnB,0BAA0B;AAC1B,kBAAkB;AAClB,mBAAmB;;AAEnB,0CAA0C;AAC1C,2CAA2C;AAC3C,yCAAyC;AACzC,IAAI;;AAEJ,8BAA8B;AAC9B,oCAAoC;AACpC,IAAI;;AAEJ,6BAA6B;AAC7B,oCAAoC;AACpC,IAAI;;AAEJ,gBAAgB;AAChB,6CAA6C;AAC7C,IAAI;;AAEJ,wBAAwB;AACxB,sDAAsD;AACtD,IAAI;;AAEJ,uCAAuC;AACvC,gBAAgB;AAChB,yBAAyB;AACzB,uBAAuB;AACvB,IAAI;;AAEJ,6BAA6B;AAC7B,qBAAqB;AACrB,sBAAsB;AACtB,4CAA4C;AAC5C,IAAI;;AAEJ,wBAAwB;AACxB,sBAAsB;AACtB,4CAA4C;AAC5C,IAAI;;AAEJ,sBAAsB;AACtB,sBAAsB;AACtB,2CAA2C;AAC3C,IAAI;;AAEJ,cAAc;AACd,sBAAsB;AACtB,oCAAoC;AACpC,IAAI;;AAEJ,4BAA4B;AAC5B,0CAA0C;AAC1C,IAAI;;AAEJ,kBAAkB;AAClB,2BAA2B;AAC3B,4CAA4C;AAC5C,IAAI;;AAEJ,8BAA8B;AAC9B,4CAA4C;AAC5C,IAAI;;AAEJ,4BAA4B;AAC5B,2CAA2C;AAC3C,IAAI;;AAEJ;;6BAE6B;AAC7B;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA,qBAAqB;AACrB;IACI,KAAK,uBAAuB,EAAE;IAC9B,MAAM,yBAAyB,EAAE;IACjC,MAAM,wBAAwB,EAAE;IAChC,MAAM,yBAAyB,EAAE;IACjC,MAAM,wBAAwB,EAAE;IAChC,OAAO,uBAAuB,EAAE;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;6BAE6B;AAC7B;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,wCAAwC;IACxC,kCAAkC;IAClC,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,wBAAwB;AACxB;IACI,+CAA+C;AACnD;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,2BAA2B;IAC/B;AACJ;;AAEA,WAAW;AACX;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kCAAkC;IAClC,mCAAmC;IACnC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;;6BAE6B;AAC7B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,UAAU;AACV;IACI,SAAO;IACP,wBAAwB;AAC5B;;AAEA;;6BAE6B;AAC7B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;6BAE6B;AAC7B;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;AACtC;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;;AAGA,cAAc;;AAEd;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB,EAAE,aAAa;IAClC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB,EAAE,2BAA2B;IAChD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;IAC5B,aAAa;IACb,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA,oCAAoC;AACpC;IACI,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;IAC5B,aAAa;IACb,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA,oCAAoC;AACpC;IACI,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,2BAA2B;;AAE3B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;;IAE3B,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,YAAY;IACZ,kBAAkB;;IAElB,oCAAoC;IACpC,cAAc;;IAEd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;;IAE3B,YAAY;;IAEZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;;IAEnB,gDAAgD;AACpD;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;IACX,WAAW;IACX,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ;;;;KAIC;AACL;;AAEA;IACI,eAAe;;IAEf,kBAAkB;IAClB,eAAe;;IAEf,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;;IAEP,WAAW;IACX,oBAAoB;IACpB,sBAAsB;AAC1B;;;AAGA,aAAa;AACb;IACI;QACI,qCAAqC;IACzC;IACA;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;;AAGA,WAAW;AACX;IACI;QACI,cAAc;IAClB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;QAC1B,SAAS;IACb;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,eAAe;QACf,OAAO;QACP,MAAM;QACN,+BAA+B;QAC/B,YAAY;QACZ,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,eAAe;QACf;IACJ;IACA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;;;;QAII,YAAY;QACZ,cAAc,EAAE,4BAA4B;IAChD;;IAEA;QACI,mBAAmB,EAAE,6BAA6B;QAClD,eAAe;IACnB;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,eAAe;QACf,cAAc;IAClB;;AAEJ","sourcesContent":[":root {\r\n    --primary: #98e3da;\r\n    --primary-dark: #6fb8af;\r\n    --bg: #f5f7fa;\r\n    --text: #1f2933;\r\n    --card-bg: #ffffff;\r\n}\r\n\r\n/* RESET */\r\n* {\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n}\r\n\r\nbody, html, #root {\r\n    height: 100%;\r\n    background: var(--bg);\r\n    color: var(--text);\r\n}\r\n\r\n/* LAYOUT */\r\n.dashboard {\r\n    display: flex;\r\n    min-height: 100vh;\r\n}\r\n\r\n/* SIDEBAR */\r\n.sidebar {\r\n    width: 260px;\r\n    background: var(--primary);\r\n    color: #0b1f24;\r\n    padding: 24px 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.sidebar-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    font-size: 1.4rem;\r\n    font-weight: 700;\r\n    margin-bottom: 32px;\r\n}\r\n\r\n.nav-section-title {\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.08em;\r\n    opacity: 0.8;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.nav {\r\n    list-style: none;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.nav li {\r\n    margin-bottom: 6px;\r\n}\r\n\r\n.nav a {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px 12px;\r\n    border-radius: 8px;\r\n    text-decoration: none;\r\n    color: #0b1f24;\r\n    font-size: 0.9rem;\r\n    transition: background 0.2s, transform 0.1s;\r\n    cursor: pointer;\r\n}\r\n\r\n.nav a:hover {\r\n    background: rgba(255, 255, 255, 0.6);\r\n    transform: translateX(2px);\r\n}\r\n\r\n.nav a.active {\r\n    background: #ffffff;\r\n    font-weight: 600;\r\n}\r\n\r\n.sidebar-footer {\r\n    margin-top: auto;\r\n    font-size: 0.8rem;\r\n    opacity: 0.8;\r\n}\r\n\r\n.main {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n/* Form controls (inputs / textarea) consistent with site DA */\r\n.form-input,\r\n.form-textarea {\r\n    width: 100%;\r\n    padding: 10px 12px;\r\n    border-radius: 8px;\r\n    border: 1px solid #e3e7f0;\r\n    background: var(--card-bg);\r\n    color: var(--text);\r\n    font-size: 0.95rem;\r\n    outline: none;\r\n    transition: box-shadow 0.12s ease, border-color 0.12s ease;\r\n}\r\n\r\n.form-input:focus,\r\n.form-textarea:focus {\r\n    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);\r\n    border-color: rgba(111,184,175,0.9);\r\n}\r\n\r\n.form-textarea { min-height: 120px; resize: vertical; }\r\n\r\n/* Chat admin input/button styles */\r\n.chat-admin-input-row {\r\n    display: flex;\r\n    gap: 8px;\r\n    padding: 8px;\r\n    border-top: 1px solid rgba(0,0,0,0.06);\r\n}\r\n.chat-admin-input {\r\n    flex: 1;\r\n    padding: 10px 12px;\r\n    border-radius: 8px;\r\n    border: 1px solid #e3e7f0;\r\n    background: var(--card-bg, #fff);\r\n    color: var(--text, #111);\r\n    outline: none;\r\n    transition: box-shadow 0.12s ease, border-color 0.12s ease;\r\n}\r\n.chat-admin-input:focus {\r\n    box-shadow: 0 6px 18px rgba(15,23,42,0.06);\r\n    border-color: rgba(11,132,255,0.9);\r\n}\r\n.chat-admin-btn {\r\n    background: #007bff;\r\n    color: #fff;\r\n    border: none;\r\n    padding: 8px 14px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    transition: transform 0.08s ease, box-shadow 0.12s ease;\r\n}\r\n.chat-admin-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(0,0,0,0.08); }\r\n.chat-admin-btn:disabled { opacity: 0.6; cursor: default; transform: none; box-shadow: none; }\r\n\r\n/* Dark mode */\r\n.dashboard.dark .chat-admin-input-row { border-top-color: rgba(255,255,255,0.06); }\r\n.dashboard.dark .chat-admin-input { background: #0b1730; color: #e6eef6; border-color: rgba(255,255,255,0.08); }\r\n.dashboard.dark .chat-admin-input::placeholder { color: rgba(230,238,246,0.6); }\r\n.dashboard.dark .chat-admin-input:focus { box-shadow: 0 6px 18px rgba(11,132,255,0.12); border-color: rgba(11,132,255,0.9); }\r\n.dashboard.dark .chat-admin-btn { background: #0b84ff; }\r\n\r\n/* Chat admin action buttons */\r\n.chat-btn {\r\n    font-size: 12px;\r\n    padding: 6px 10px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    border: 1px solid transparent;\r\n    background: transparent;\r\n}\r\n.chat-btn-ghost {\r\n    background: transparent;\r\n    color: var(--text, #111);\r\n    border-color: rgba(0,0,0,0.06);\r\n}\r\n.chat-btn-ghost:hover { background: rgba(0,0,0,0.03); }\r\n.chat-btn-danger {\r\n    background: #dc3545;\r\n    color: #fff;\r\n    border-color: rgba(0,0,0,0.06);\r\n}\r\n.chat-btn-danger:hover { filter: brightness(0.95); transform: translateY(-1px); }\r\n.chat-btn:disabled { opacity: 0.6; cursor: default; transform: none; }\r\n\r\n/* Dark theme overrides */\r\n.dashboard.dark .chat-btn-ghost { color: #e6eef6; border-color: rgba(255,255,255,0.04); }\r\n.dashboard.dark .chat-btn-ghost:hover { background: rgba(255,255,255,0.02); }\r\n.dashboard.dark .chat-btn-danger { background: #d14343; }\r\n\r\n/* Dark mode variants for form controls */\r\n.dashboard.dark .form-input,\r\n.dashboard.dark .form-textarea {\r\n    background: #0f1418; /* same as search input in dark */\r\n    border: 1px solid #2a333a;\r\n    color: var(--text);\r\n}\r\n.dashboard.dark .form-input:focus,\r\n.dashboard.dark .form-textarea:focus {\r\n    box-shadow: 0 6px 18px rgba(0,0,0,0.6);\r\n    border-color: rgba(111,184,175,0.3);\r\n}\r\n\r\n/* Announce page: embed fields responsive row */\r\n.embed-field-row {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 160px;\r\n    gap: 8px;\r\n    margin-top: 8px;\r\n    align-items: start;\r\n}\r\n\r\n/* Button and checkbox group inside the last column */\r\n.embed-field-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n    .embed-field-row {\r\n        grid-template-columns: 1fr;\r\n    }\r\n    .embed-field-actions {\r\n        justify-content: flex-start;\r\n    }\r\n}\r\n\r\n/* Themed color picker for Announce page */\r\n.color-picker {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    position: relative;\r\n}\r\n\r\n.color-swatch {\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 8px;\r\n    border: 1px solid rgba(15,23,42,0.08);\r\n    box-shadow: 0 4px 12px rgba(15,23,42,0.06);\r\n    cursor: pointer;\r\n}\r\n\r\n.color-popover {\r\n    position: absolute;\r\n    top: 44px;\r\n    left: 0;\r\n    background: var(--card-bg);\r\n    border: 1px solid #e3e7f0;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 10px 30px rgba(15,23,42,0.12);\r\n    z-index: 60;\r\n    min-width: 260px;\r\n}\r\n\r\n.dashboard.dark .color-popover {\r\n    background: #1a2228;\r\n    border-color: #2a333a;\r\n}\r\n\r\n.color-presets {\r\n    display: grid;\r\n    grid-template-columns: repeat(8, 1fr);\r\n    gap: 8px;\r\n    margin-top: 8px;\r\n}\r\n\r\n.preset-swatch {\r\n    width: 28px;\r\n    height: 28px;\r\n    border-radius: 6px;\r\n    border: 1px solid rgba(15,23,42,0.06);\r\n    cursor: pointer;\r\n}\r\n\r\n.native-color-input {\r\n    width: 40px;\r\n    height: 34px;\r\n    padding: 0;\r\n    border: none;\r\n    background: transparent;\r\n}\r\n\r\n@media (max-width: 520px) {\r\n    .color-popover { left: auto; right: 0; min-width: 220px; }\r\n    .color-presets { grid-template-columns: repeat(6, 1fr); }\r\n}\r\n\r\n/* TOPBAR */\r\n.topbar {\r\n    width: 100%;\r\n    height: 64px;\r\n    background: #ffffff;\r\n    border-bottom: 1px solid #e1e4ea;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 24px;\r\n    /*overflow: hidden;*/\r\n}\r\n\r\n.topbar-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n.topbar-title {\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.search {\r\n    padding: 8px 12px;\r\n    border-radius: 999px;\r\n    border: 1px solid #d0d7e2;\r\n    font-size: 0.9rem;\r\n    min-width: 220px;\r\n    outline: none;\r\n}\r\n\r\n.topbar-right {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n}\r\n\r\n.badge {\r\n    background: var(--primary);\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 190px;\r\n    color: #0b1f24;\r\n    padding: 4px 10px;\r\n    border-radius: 999px;\r\n    font-size: 0.75rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.avatar {\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    background: var(--primary-dark);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #ffffff;\r\n    font-size: 0.85rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.avatar:hover {\r\n    opacity: 0.8;\r\n}\r\n\r\n\r\n/* CONTENT */\r\n.content {\r\n    padding: 24px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.cards {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n    gap: 16px;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n/* CARD */\r\n.card {\r\n    background: var(--card-bg);\r\n    border-radius: 14px;\r\n    padding: 16px 18px;\r\n    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);\r\n    border: 1px solid #e3e7f0;\r\n}\r\n\r\n.card-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.card-title {\r\n    font-size: 0.9rem;\r\n    font-weight: 600;\r\n    opacity: 0.8;\r\n}\r\n\r\n.card-value {\r\n    font-size: 1.4rem;\r\n    font-weight: 700;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.card-sub {\r\n    font-size: 0.8rem;\r\n    opacity: 0.7;\r\n}\r\n\r\n.chip {\r\n    font-size: 0.75rem;\r\n    padding: 3px 8px;\r\n    border-radius: 999px;\r\n    background: rgba(152, 227, 218, 0.2);\r\n    color: #0b1f24;\r\n    font-weight: 500;\r\n}\r\n\r\n/* TABLE + CHART LAYOUT */\r\n.layout-two-cols {\r\n    display: grid;\r\n    grid-template-columns: 2fr 1.2fr;\r\n    gap: 20px;\r\n}\r\n\r\n/* TABLE */\r\n.table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 0.85rem;\r\n}\r\n\r\n.table thead {\r\n    background: #f0f3f9;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n    padding: 10px 8px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #e3e7f0;\r\n}\r\n\r\n.table th {\r\n    font-weight: 600;\r\n    font-size: 0.8rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.04em;\r\n    opacity: 0.8;\r\n}\r\n\r\n/* STATUS BADGES */\r\n.status {\r\n    padding: 4px 8px;\r\n    border-radius: 999px;\r\n    font-size: 0.75rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.status-success {\r\n    background: rgba(152, 227, 218, 0.2);\r\n    color: #0b3b32;\r\n}\r\n\r\n.status-pending {\r\n    background: #fff7e0;\r\n    color: #8a5b00;\r\n}\r\n\r\n/* Announce preview styles (Discord-like) */\r\n.announce-raw-message {\r\n    white-space: pre-wrap;\r\n    font-size: 0.95rem;\r\n    padding: 0;\r\n    margin: 0;\r\n    background: transparent;\r\n    border: none;\r\n    color: inherit;\r\n}\r\n.dashboard.dark .announce-raw-message {\r\n    background: transparent;\r\n    border: none;\r\n    color: #e6edf3;\r\n}\r\n\r\n.announce-embed {\r\n    display: flex;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    background: #ffffff;\r\n    box-shadow: 0 6px 18px rgba(2,6,23,0.06);\r\n    border: 1px solid #e6eef6;\r\n}\r\n.dashboard.dark .announce-embed {\r\n    background: #202225;\r\n    box-shadow: none;\r\n    border-color: #2a2d30;\r\n}\r\n\r\n.announce-embed-colorbar {\r\n    width: 8px;\r\n}\r\n\r\n.announce-embed-body {\r\n    padding: 12px 14px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.announce-embed-author {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n.announce-embed-author .avatar-sm {\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 50%;\r\n    background: #98e3da;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: 700;\r\n    color: #032018;\r\n}\r\n.announce-embed-title {\r\n    font-weight: 700;\r\n    font-size: 1rem;\r\n    color: #0f172a;\r\n}\r\n.dashboard.dark .announce-embed-title { color: #ffffff; }\r\n\r\n.announce-embed-description {\r\n    color: #374151;\r\n    font-size: 0.95rem;\r\n    line-height: 1.35;\r\n    white-space: pre-wrap;\r\n}\r\n.dashboard.dark .announce-embed-description { color: #cbd5e1; }\r\n\r\n.announce-embed-fields {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n}\r\n.announce-embed-field {\r\n    background: #f8fafc;\r\n    padding: 8px;\r\n    border-radius: 6px;\r\n    /* allow up to 3 inline fields per row */\r\n    min-width: 120px;\r\n    flex: 1 1 30%;\r\n}\r\n.announce-embed-field-name {\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    color: #0f172a;\r\n}\r\n.announce-embed-field-value {\r\n    margin-top: 6px;\r\n    color: #334155;\r\n    font-size: 13px;\r\n    white-space: pre-wrap;\r\n}\r\n.dashboard.dark .announce-embed-field { background: #2b2d30; }\r\n.dashboard.dark .announce-embed-field-name { color: #fff; }\r\n.dashboard.dark .announce-embed-field-value { color: #cbd5e1; }\r\n\r\n@media (max-width: 640px) {\r\n    .announce-embed-field { flex: 1 1 100%; min-width: 100%; }\r\n}\r\n\r\n\r\n.status-cancelled {\r\n    background: #ffe5e5;\r\n    color: #8a1f1f;\r\n}\r\n\r\n/* CHART PLACEHOLDER */\r\n.card-chart-placeholder {\r\n    height: 220px;\r\n    border-radius: 12px;\r\n    background: repeating-linear-gradient(\r\n            -45deg,\r\n            #f3f6fb,\r\n            #f3f6fb 8px,\r\n            #e4ebf7 8px,\r\n            #e4ebf7 16px\r\n    );\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.85rem;\r\n    color: #6b7280;\r\n}\r\n\r\n.dark {\r\n    --bg: #0f1418;\r\n    --text: #e5e9ec;\r\n    --card-bg: #1a2228;\r\n    --primary: #98e3da;\r\n    --primary-dark: #6fb8af;\r\n}\r\n\r\n.dark body,\r\n.dashboard.dark {\r\n    background: var(--bg);\r\n    color: var(--text);\r\n}\r\n\r\n.dashboard.dark .sidebar {\r\n    background: #132025;\r\n    color: var(--text);\r\n}\r\n\r\n.dashboard.dark .nav a {\r\n    color: var(--text);\r\n}\r\n\r\n.dashboard.dark .nav a:hover {\r\n    background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.dashboard.dark .nav a.active {\r\n    background: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n.dashboard.dark .topbar {\r\n    background: #1a2228;\r\n    border-bottom: 1px solid #2a333a;\r\n}\r\n\r\n.dashboard.dark .search {\r\n    background: #0f1418;\r\n    border: 1px solid #2a333a;\r\n    color: var(--text);\r\n}\r\n\r\n.dashboard.dark .card {\r\n    background: var(--card-bg);\r\n    border: 1px solid #2a333a;\r\n}\r\n\r\n.dashboard.dark .table thead {\r\n    background: #222c33;\r\n}\r\n\r\n.dashboard.dark .table td,\r\n.dashboard.dark .table th {\r\n    border-bottom: 1px solid #2a333a;\r\n}\r\n\r\n.dashboard.dark .card-chart-placeholder {\r\n    background: repeating-linear-gradient(\r\n            -45deg,\r\n            #1f2a30,\r\n            #1f2a30 8px,\r\n            #25333a 8px,\r\n            #25333a 16px\r\n    );\r\n    color: #9aa5ac;\r\n}\r\n\r\n.dashboard.dark .status-success {\r\n    background: rgba(152, 227, 218, 0.15);\r\n    color: #98e3da;\r\n}\r\n\r\n.dashboard.dark .status-pending {\r\n    background: rgba(255, 200, 100, 0.15);\r\n    color: #ffcc66;\r\n}\r\n\r\n.dashboard.dark .status-cancelled {\r\n    background: rgba(255, 120, 120, 0.15);\r\n    color: #ff8a8a;\r\n}\r\n\r\n.theme-toggle {\r\n    background: transparent;\r\n    border: 1px solid #d0d7e2;\r\n    padding: 6px 10px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 1rem;\r\n    transition: 0.2s;\r\n}\r\n\r\n.theme-toggle:hover {\r\n    background: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .theme-toggle {\r\n    border-color: #2a333a;\r\n    color: #e5e9ec;\r\n}\r\n\r\n/* Styled tooltip used in small tables (Activité récente) */\r\n.cell-with-tooltip {\r\n    position: relative;\r\n    display: inline-block;\r\n    cursor: default;\r\n    outline: none;\r\n}\r\n\r\n.cell-with-tooltip:focus {\r\n    /* subtle focus ring for keyboard users */\r\n    box-shadow: 0 0 0 4px rgba(152,227,218,0.18);\r\n    border-radius: 6px;\r\n}\r\n\r\n.cell-with-tooltip .tooltip {\r\n    pointer-events: none;\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: calc(100% + 8px);\r\n    transform-origin: left bottom;\r\n    background: #0b1f24;\r\n    color: #fff;\r\n    padding: 8px 10px;\r\n    border-radius: 8px;\r\n    font-size: 0.85rem;\r\n    line-height: 1.2;\r\n    max-width: 320px;\r\n    white-space: normal;\r\n    box-shadow: 0 6px 18px rgba(15,23,42,0.2);\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: opacity 0.12s ease, transform 0.12s ease, visibility 0.12s;\r\n    z-index: 50;\r\n}\r\n\r\n.cell-with-tooltip .tooltip::after {\r\n    content: '';\r\n    position: absolute;\r\n    left: 12px;\r\n    top: 100%;\r\n    width: 8px;\r\n    height: 8px;\r\n    background: inherit;\r\n    transform: rotate(45deg);\r\n}\r\n\r\n.cell-with-tooltip:hover .tooltip,\r\n.cell-with-tooltip:focus .tooltip,\r\n.cell-with-tooltip:focus-within .tooltip {\r\n    opacity: 1;\r\n    visibility: visible;\r\n    transform: translateY(0) scale(1);\r\n}\r\n\r\n/* Dark mode tooltip tweaks */\r\n.dashboard.dark .cell-with-tooltip .tooltip {\r\n    background: #111a1d;\r\n    color: #e5e9ec;\r\n}\r\n\r\n/* Presence badge like Discord */\r\n.presence-badge {\r\n    display: none; /* badge now integrated into the pill-style label */\r\n}\r\n\r\n/* Clean pill-style presence label */\r\n.presence-label {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 6px 10px;\r\n    border-radius: 999px;\r\n    font-weight: 600;\r\n    font-size: 0.85rem;\r\n    line-height: 1;\r\n    text-transform: none;\r\n    box-shadow: none;\r\n    transition: background-color 0.12s ease, color 0.12s ease, transform 0.08s ease;\r\n}\r\n\r\n.presence-label::before {\r\n    content: '';\r\n    display: inline-block;\r\n    width: 8px;\r\n    height: 8px;\r\n    border-radius: 50%;\r\n    margin-right: 6px;\r\n}\r\n\r\n.presence-label.presence-online { color: #0b4f41; background: rgba(67,181,129,0.12); }\r\n.presence-label.presence-online::before { background: #43b581; }\r\n\r\n.presence-label.presence-idle { color: #6b4a10; background: rgba(250,166,26,0.08); }\r\n.presence-label.presence-idle::before { background: #faa61a; }\r\n\r\n.presence-label.presence-dnd { color: #7a2b2b; background: rgba(240,71,71,0.08); }\r\n.presence-label.presence-dnd::before { background: #f04747; }\r\n\r\n.presence-label.presence-offline { color: #39424a; background: rgba(116,127,141,0.06); }\r\n.presence-label.presence-offline::before { background: #747f8d; }\r\n\r\n.presence-label:hover { transform: translateY(-1px); }\r\n\r\n.dashboard.dark .presence-label.presence-online {\r\n    background: rgba(67,181,129,0.12);\r\n    color: #dbf7ee; /* lighter text for contrast */\r\n    border: 1px solid rgba(67,181,129,0.06);\r\n}\r\n.dashboard.dark .presence-label.presence-online::before {\r\n    background: #43b581;\r\n    box-shadow: 0 0 8px rgba(67,181,129,0.12);\r\n}\r\n\r\n.dashboard.dark .presence-label.presence-idle {\r\n    background: rgba(250,166,26,0.10);\r\n    color: #ffeecd; /* warm light text */\r\n    border: 1px solid rgba(250,166,26,0.06);\r\n}\r\n.dashboard.dark .presence-label.presence-idle::before {\r\n    background: #faa61a;\r\n    box-shadow: 0 0 6px rgba(250,166,26,0.08);\r\n}\r\n\r\n.dashboard.dark .presence-label.presence-dnd {\r\n    background: rgba(240,71,71,0.10);\r\n    color: #ffd6d6; /* soft light red */\r\n    border: 1px solid rgba(240,71,71,0.06);\r\n}\r\n.dashboard.dark .presence-label.presence-dnd::before {\r\n    background: #f04747;\r\n    box-shadow: 0 0 6px rgba(240,71,71,0.08);\r\n}\r\n\r\n.dashboard.dark .presence-label.presence-offline {\r\n    background: rgba(116,127,141,0.06);\r\n    color: #cbd5dd; /* neutral light */\r\n    border: 1px solid rgba(255,255,255,0.02);\r\n}\r\n.dashboard.dark .presence-label.presence-offline::before {\r\n    background: #9aa5ac;\r\n}\r\n\r\n.dashboard.dark .theme-toggle:hover {\r\n    background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* Avatar wrapper */\r\n.avatar-wrapper {\r\n    position: relative;\r\n}\r\n\r\n/* Menu utilisateur */\r\n.user-menu {\r\n    position: absolute;\r\n    top: 40px;\r\n    right: 0;\r\n    background: var(--card-bg);\r\n    /*border: 1px solid #e3e7f0;*/\r\n    border: 1px solid #cfd6dd;\r\n    border-radius: 10px;\r\n    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);\r\n    padding: 8px 0;\r\n    width: 160px;\r\n    z-index: 20;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n/* Petite flèche du menu utilisateur */\r\n/* Flèche du menu utilisateur */\r\n.user-menu::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -12px;\r\n    right: 18px;\r\n    width: 0;\r\n    height: 0;\r\n\r\n    /* Flèche visible */\r\n    border-left: 8px solid transparent;\r\n    border-right: 8px solid transparent;\r\n    border-bottom: 12px solid var(--card-bg);\r\n\r\n    /* Bordure autour de la flèche */\r\n    z-index: -1;\r\n}\r\n\r\n.user-menu::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -14px;\r\n    right: 18px;\r\n    width: 0;\r\n    height: 0;\r\n\r\n    /* Bordure de la flèche */\r\n    border-left: 9px solid transparent;\r\n    border-right: 9px solid transparent;\r\n    border-bottom: 13px solid #cfd6dd; /* bordure claire */\r\n}\r\n\r\n/* Version Dark Mode */\r\n.dark .user-menu::after {\r\n    border-bottom-color: #2a333a; /* bordure foncée */\r\n}\r\n\r\n.dark .user-menu::before {\r\n    border-bottom-color: #1a2228; /* couleur du menu dark */\r\n}\r\n\r\n\r\n\r\n.user-menu button {\r\n    background: none;\r\n    border: none;\r\n    padding: 10px 14px;\r\n    text-align: left;\r\n    width: 100%;\r\n    font-size: 0.9rem;\r\n    cursor: pointer;\r\n    color: var(--text);\r\n}\r\n\r\n.user-menu button:hover {\r\n    background: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* Dark mode */\r\n.dark .user-menu {\r\n    background: #1a2228;\r\n    border-color: #2a333a;\r\n}\r\n\r\n.dark .user-menu button:hover {\r\n    background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.avatar {\r\n    cursor: pointer;\r\n}\r\n\r\n.user-menu button {\r\n    cursor: pointer;\r\n}\r\n\r\n/* Animation fade + slide */\r\n@keyframes fadeSlideIn {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translateY(-6px);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* Appliquer l’animation au menu */\r\n.user-menu {\r\n    animation: fadeSlideIn 0.18s ease-out;\r\n}\r\n\r\n@keyframes fadeSlideOut {\r\n    0% {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n    100% {\r\n        opacity: 0;\r\n        transform: translateY(-6px);\r\n    }\r\n}\r\n\r\n.user-menu.closing {\r\n    animation: fadeSlideOut 0.15s ease-in forwards;\r\n}\r\n\r\n/* Groupe des statuts serveurs */\r\n.server-status-group {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    margin-left: 20px;\r\n}\r\n\r\n.server-status {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    font-size: 0.85rem;\r\n    opacity: 0.9;\r\n}\r\n\r\n.status-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.status-dot.online {\r\n    background: #4caf50;\r\n}\r\n\r\n.status-dot.offline {\r\n    background: #e53935;\r\n}\r\n\r\n.dark .server-status {\r\n    color: #e5e9ec;\r\n}\r\n\r\n/* Followmaj icon in Requests table */\r\n.followmaj {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 28px;\r\n    height: 20px;\r\n    border-radius: 6px;\r\n    font-weight: 700;\r\n}\r\n.followmaj.true { color: #10b981; background: rgba(16,185,129,0.06); border: 1px solid rgba(16,185,129,0.08); }\r\n.followmaj.false { color: #ef4444; background: rgba(239,68,68,0.06); border: 1px solid rgba(239,68,68,0.06); }\r\n.dashboard.dark .followmaj.true { background: rgba(16,185,129,0.10); }\r\n.dashboard.dark .followmaj.false { background: rgba(239,68,68,0.10); }\r\n\r\n/* center specific table columns */\r\n.table th.center-col,\r\n.table td.center-col {\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    /* Prevent header/cell text from wrapping (keep labels like \"Suivi MAJ\" on one line) */\r\n    white-space: nowrap;\r\n}\r\n\r\n/* narrower user column for Requests table */\r\n.table .col-user {\r\n    /* revert to default flow so user names aren't truncated */\r\n    width: auto;\r\n    max-width: none;\r\n    white-space: normal;\r\n    overflow: visible;\r\n}\r\n.table .col-user strong {\r\n    display: inline-block;\r\n    max-width: none;\r\n    white-space: normal;\r\n    overflow: visible;\r\n    text-overflow: unset;\r\n}\r\n\r\n/* Suivi MAJ column: keep it wide enough to avoid wrapping */\r\n.table th.center-col {\r\n    min-width: 96px; /* increased so \"Suivi MAJ\" doesn't wrap */\r\n    width: auto;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* Animation pulsante façon Discord */\r\n@keyframes pulseOnline {\r\n    0% {\r\n        transform: scale(1);\r\n        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.6);\r\n    }\r\n    70% {\r\n        transform: scale(1.15);\r\n        box-shadow: 0 0 10px 6px rgba(76, 175, 80, 0);\r\n    }\r\n    100% {\r\n        transform: scale(1);\r\n        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);\r\n    }\r\n}\r\n\r\n/* Appliquer l’animation au rond vert */\r\n.status-dot.online {\r\n    background: #4caf50;\r\n    animation: pulseOnline 1.8s infinite ease-out;\r\n}\r\n\r\n/* Animation clignotante rouge (erreur critique) */\r\n@keyframes blinkOffline {\r\n    0% {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n    50% {\r\n        opacity: 0.35;\r\n        transform: scale(0.85);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n/* Appliquer l’animation au rond rouge */\r\n.status-dot.offline {\r\n    background: #e53935;\r\n    animation: blinkOffline 1.4s infinite ease-in-out;\r\n}\r\n\r\n/* Tooltip général */\r\n.server-status {\r\n    position: relative;\r\n}\r\n\r\n/* Bulle du tooltip (désormais en dessous) */\r\n.server-status:hover::after {\r\n    content: attr(data-tooltip);\r\n    position: absolute;\r\n    top: 26px; /* en dessous du rond */\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background: var(--card-bg);\r\n    color: var(--text);\r\n    padding: 6px 10px;\r\n    font-size: 0.75rem;\r\n    border-radius: 6px;\r\n    white-space: nowrap;\r\n    border: 1px solid #cfd6dd;\r\n    opacity: 0;\r\n    animation: tooltipFadeDown 0.18s forwards ease-out;\r\n    pointer-events: none;\r\n    z-index: 50;\r\n}\r\n\r\n/* Petite flèche (vers le haut cette fois) */\r\n.server-status:hover::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 18px; /* juste sous le rond */\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    border-left: 6px solid transparent;\r\n    border-right: 6px solid transparent;\r\n    border-top: 6px solid var(--card-bg);\r\n    opacity: 0;\r\n    animation: tooltipFadeDown 0.18s forwards ease-out;\r\n    z-index: 49;\r\n}\r\n\r\n/* Animation fade + slide vers le bas */\r\n@keyframes tooltipFadeDown {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translate(-50%, -4px);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: translate(-50%, 0);\r\n    }\r\n}\r\n\r\n/* Dark mode */\r\n.dark .server-status:hover::after {\r\n    background: #1a2228;\r\n    border-color: #2a333a;\r\n    color: #e5e9ec;\r\n}\r\n\r\n.dark .server-status:hover::before {\r\n    border-top-color: #1a2228;\r\n}\r\n\r\n/*.notif-wrapper {*/\r\n/*    position: relative;*/\r\n/*}*/\r\n\r\n/*.notif-bell {*/\r\n/*    position: relative;*/\r\n/*    font-size: 1.3rem;*/\r\n/*    cursor: pointer;*/\r\n/*    margin-right: 14px;*/\r\n/*}*/\r\n\r\n/*.notif-badge {*/\r\n/*    position: absolute;*/\r\n/*    top: -4px;*/\r\n/*    right: -6px;*/\r\n/*    background: #e53935;*/\r\n/*    color: white;*/\r\n/*    font-size: 0.65rem;*/\r\n/*    padding: 2px 5px;*/\r\n/*    border-radius: 50%;*/\r\n/*}*/\r\n\r\n/*@keyframes shakeBell {*/\r\n/*    0% { transform: rotate(0deg); }*/\r\n/*    20% { transform: rotate(-15deg); }*/\r\n/*    40% { transform: rotate(15deg); }*/\r\n/*    60% { transform: rotate(-10deg); }*/\r\n/*    80% { transform: rotate(10deg); }*/\r\n/*    100% { transform: rotate(0deg); }*/\r\n/*}*/\r\n\r\n/*.notif-bell.shake {*/\r\n/*    animation: shakeBell 0.6s ease;*/\r\n/*}*/\r\n\r\n/*.notif-menu {*/\r\n/*    position: absolute;*/\r\n/*    top: 36px;*/\r\n/*    right: 0;*/\r\n/*    background: var(--card-bg);*/\r\n/*    border: 1px solid #cfd6dd;*/\r\n/*    border-radius: 10px;*/\r\n/*    width: 240px;*/\r\n/*    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);*/\r\n/*    padding: 8px 0;*/\r\n/*    animation: fadeSlideIn 0.18s ease-out;*/\r\n/*    z-index: 30;*/\r\n/*}*/\r\n\r\n/*.notif-item {*/\r\n/*    padding: 10px 14px;*/\r\n/*    font-size: 0.85rem;*/\r\n/*    border-bottom: 1px solid rgba(0,0,0,0.05);*/\r\n/*}*/\r\n\r\n/*.notif-item:last-child {*/\r\n/*    border-bottom: none;*/\r\n/*}*/\r\n\r\n/*!* Couleurs selon type *!*/\r\n/*.notif-item.info { color: #1976d2; }*/\r\n/*.notif-item.success { color: #2e7d32; }*/\r\n/*.notif-item.error { color: #d32f2f; }*/\r\n\r\n/*.dark .notif-menu {*/\r\n/*    background: #1a2228;*/\r\n/*    border-color: #2a333a;*/\r\n/*}*/\r\n\r\n/*.dark .notif-item {*/\r\n/*    border-bottom-color: rgba(255,255,255,0.08);*/\r\n/*}*/\r\n\r\n/*!* Flèche du menu notifications *!*/\r\n/*.notif-menu::before {*/\r\n/*    content: \"\";*/\r\n/*    position: absolute;*/\r\n/*    top: -10px;*/\r\n/*    right: 14px;*/\r\n/*    width: 0;*/\r\n/*    height: 0;*/\r\n\r\n/*    border-left: 8px solid transparent;*/\r\n/*    border-right: 8px solid transparent;*/\r\n/*    border-bottom: 10px solid var(--card-bg);*/\r\n/*}*/\r\n\r\n/*!* Bordure de la flèche *!*/\r\n/*.notif-menu::after {*/\r\n/*    content: \"\";*/\r\n/*    position: absolute;*/\r\n/*    top: -12px;*/\r\n/*    right: 13px;*/\r\n\r\n/*    border-left: 9px solid transparent;*/\r\n/*    border-right: 9px solid transparent;*/\r\n/*    border-bottom: 12px solid #cfd6dd;*/\r\n/*}*/\r\n\r\n/*.dark .notif-menu::before {*/\r\n/*    border-bottom-color: #1a2228;*/\r\n/*}*/\r\n\r\n/*.dark .notif-menu::after {*/\r\n/*    border-bottom-color: #2a333a;*/\r\n/*}*/\r\n\r\n/*.notif-menu {*/\r\n/*    animation: fadeSlideIn 0.18s ease-out;*/\r\n/*}*/\r\n\r\n/*.notif-menu.closing {*/\r\n/*    animation: fadeSlideOut 0.15s ease-in forwards;*/\r\n/*}*/\r\n\r\n/*!* Icône dans chaque notification *!*/\r\n/*.notif-icon {*/\r\n/*    margin-right: 8px;*/\r\n/*    font-size: 1rem;*/\r\n/*}*/\r\n\r\n/*!* Styles par catégorie *!*/\r\n/*.notif-item.info {*/\r\n/*    color: #1976d2;*/\r\n/*    background: rgba(25, 118, 210, 0.08);*/\r\n/*}*/\r\n\r\n/*.notif-item.warning {*/\r\n/*    color: #f9a825;*/\r\n/*    background: rgba(249, 168, 37, 0.12);*/\r\n/*}*/\r\n\r\n/*.notif-item.error {*/\r\n/*    color: #d32f2f;*/\r\n/*    background: rgba(211, 47, 47, 0.12);*/\r\n/*}*/\r\n\r\n/*!* Hover *!*/\r\n/*.notif-item:hover {*/\r\n/*    background: rgba(0,0,0,0.06);*/\r\n/*}*/\r\n\r\n/*.dark .notif-item:hover {*/\r\n/*    background: rgba(255,255,255,0.06);*/\r\n/*}*/\r\n\r\n/*!* Dark mode *!*/\r\n/*.dark .notif-item.info {*/\r\n/*    background: rgba(25, 118, 210, 0.18);*/\r\n/*}*/\r\n\r\n/*.dark .notif-item.warning {*/\r\n/*    background: rgba(249, 168, 37, 0.18);*/\r\n/*}*/\r\n\r\n/*.dark .notif-item.error {*/\r\n/*    background: rgba(211, 47, 47, 0.18);*/\r\n/*}*/\r\n\r\n/* ===========================\r\n   WRAPPER & BELL\r\n=========================== */\r\n.notif-wrapper {\r\n    position: relative;\r\n}\r\n\r\n.notif-bell {\r\n    position: relative;\r\n    font-size: 1.4rem;\r\n    cursor: pointer;\r\n    margin-right: 14px;\r\n    transition: transform 0.15s ease;\r\n}\r\n\r\n.notif-bell:hover {\r\n    transform: scale(1.1);\r\n}\r\n\r\n/* Badge rouge sur la cloche */\r\n.notif-badge {\r\n    position: absolute;\r\n    top: -4px;\r\n    right: -6px;\r\n    background: #ef4444;\r\n    color: white;\r\n    font-size: 0.65rem;\r\n    padding: 2px 6px;\r\n    border-radius: 999px;\r\n    font-weight: 600;\r\n    box-shadow: 0 0 4px rgba(0,0,0,0.2);\r\n}\r\n\r\n/* Animation cloche */\r\n@keyframes shakeBell {\r\n    0% { transform: rotate(0deg); }\r\n    20% { transform: rotate(-15deg); }\r\n    40% { transform: rotate(15deg); }\r\n    60% { transform: rotate(-10deg); }\r\n    80% { transform: rotate(10deg); }\r\n    100% { transform: rotate(0deg); }\r\n}\r\n\r\n.notif-bell.shake {\r\n    animation: shakeBell 0.6s ease;\r\n}\r\n\r\n/* ===========================\r\n   MENU\r\n=========================== */\r\n.notif-menu {\r\n    position: absolute;\r\n    top: 38px;\r\n    right: 0;\r\n    width: 260px;\r\n    background: var(--card-bg);\r\n    border-radius: 12px;\r\n    padding: 6px 0;\r\n    box-shadow: 0 12px 28px rgba(0,0,0,0.12);\r\n    border: 1px solid rgba(0,0,0,0.08);\r\n    animation: notifSlideIn 0.18s ease-out;\r\n    overflow: hidden;\r\n    z-index: 50;\r\n}\r\n\r\n/* Animation ouverture */\r\n@keyframes notifSlideIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-6px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* Animation fermeture */\r\n.notif-menu.closing {\r\n    animation: notifSlideOut 0.15s ease-in forwards;\r\n}\r\n\r\n@keyframes notifSlideOut {\r\n    from {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translateY(-6px);\r\n    }\r\n}\r\n\r\n/* Flèche */\r\n.notif-menu::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -8px;\r\n    right: 16px;\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 8px solid var(--card-bg);\r\n}\r\n\r\n.notif-menu::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -10px;\r\n    right: 15px;\r\n    border-left: 8px solid transparent;\r\n    border-right: 8px solid transparent;\r\n    border-bottom: 10px solid rgba(0,0,0,0.08);\r\n}\r\n\r\n/* ===========================\r\n   ITEMS\r\n=========================== */\r\n.notif-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 12px 14px;\r\n    font-size: 0.85rem;\r\n    border-bottom: 1px solid rgba(0,0,0,0.05);\r\n    background: transparent;\r\n    transition: background 0.15s ease;\r\n}\r\n\r\n.notif-item:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.notif-item:hover {\r\n    background: rgba(0,0,0,0.04);\r\n}\r\n\r\n/* Texte */\r\n.notif-text {\r\n    flex: 1;\r\n    color: var(--text-color);\r\n}\r\n\r\n/* ===========================\r\n   BADGES\r\n=========================== */\r\n.notif-badge-type {\r\n    padding: 3px 8px;\r\n    border-radius: 6px;\r\n    font-size: 0.7rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.5px;\r\n    color: white;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* Variants */\r\n.notif-item.maj .notif-badge-type {\r\n    background: #2ec0ca;\r\n}\r\n\r\n.notif-item.user .notif-badge-type {\r\n    background: rgba(230, 14, 201, 0.8);\r\n}\r\n\r\n.notif-item.info .notif-badge-type {\r\n    background: #1976d2;\r\n}\r\n\r\n.notif-item.warning .notif-badge-type {\r\n    background: #f9a825;\r\n}\r\n\r\n.notif-item.error .notif-badge-type {\r\n    background: #d32f2f;\r\n}\r\n\r\n.notif-item.new .notif-badge-type {\r\n    background: #2fd332;\r\n}\r\n\r\n/* ===========================\r\n   DARK MODE\r\n=========================== */\r\n.dark .notif-menu {\r\n    background: #1e262c;\r\n    border-color: #2a333a;\r\n}\r\n\r\n.dark .notif-item {\r\n    border-bottom-color: rgba(255,255,255,0.06);\r\n}\r\n\r\n.dark .notif-item:hover {\r\n    background: rgba(255,255,255,0.06);\r\n}\r\n\r\n.dark .notif-text {\r\n    color: #e5e7eb;\r\n}\r\n\r\n.dark .notif-item.maj .notif-badge-type {\r\n    background: rgba(19, 183, 212, 0.8);\r\n}\r\n\r\n.dark .notif-item.user .notif-badge-type {\r\n    background: rgba(199, 12, 174, 0.8);\r\n}\r\n\r\n.dark .notif-item.info .notif-badge-type {\r\n    background: rgba(25,118,210,0.8);\r\n}\r\n\r\n.dark .notif-item.warning .notif-badge-type {\r\n    background: rgba(249,168,37,0.8);\r\n}\r\n\r\n.dark .notif-item.error .notif-badge-type {\r\n    background: rgba(211,47,47,0.8);\r\n}\r\n\r\n.dark .notif-item.new .notif-badge-type {\r\n    background: rgba(47, 211, 50, 0.8);\r\n}\r\n\r\n\r\n.notif-item.read {\r\n    opacity: 0.55;\r\n}\r\n\r\n.notif-item.read .notif-badge-type {\r\n    filter: grayscale(1);\r\n    opacity: 0.6;\r\n}\r\n\r\n.notif-item.read .notif-text {\r\n    color: #9ca3af;\r\n}\r\n\r\n\r\n/* FIN NOTIF */\r\n\r\n.admin-badge {\r\n    background: #d32f2f;\r\n    color: white;\r\n    padding: 4px 10px;\r\n    border-radius: 8px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    margin-left: 10px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n/* Badge pour les modérateurs */\r\n.moderator-badge {\r\n    background: #f9a825; /* blue-600 */\r\n    color: white;\r\n    padding: 4px 10px;\r\n    border-radius: 8px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    margin-left: 10px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.dashboard.dark .moderator-badge {\r\n    background: #f9a825; /* blue-800 for dark mode */\r\n    color: #e6edf3;\r\n    border: 1px solid rgba(255,255,255,0.04);\r\n}\r\n\r\n.sidebar-overlay {\r\n    display: none;\r\n}\r\n\r\n.sidebar-close-btn {\r\n    display: none;\r\n    background: none;\r\n    border: none;\r\n    font-size: 22px;\r\n    cursor: pointer;\r\n    margin-left: auto;\r\n}\r\n\r\n.astuce-card {\r\n    padding: 20px;\r\n    font-size: 1rem;\r\n    line-height: 1.5;\r\n    /*color: #333;*/\r\n    position: relative;\r\n    /*background: #fff8f5;*/\r\n    border-left: 4px solid #6fb8af;\r\n    border-radius: 0 0 14px 14px;\r\n    height: 250px;\r\n    overflow-y: auto;\r\n}\r\n\r\n/* Icône décorative en fond */\r\n.astuce-card::before {\r\n    content: \"🍅\";\r\n    position: absolute;\r\n    font-size: 70px;\r\n    opacity: 0.15;\r\n    right: 20px;\r\n    bottom: 10px;\r\n    pointer-events: none;\r\n}\r\n\r\n/* Animation d’apparition du texte */\r\n.astuce-card p {\r\n    animation: fadeIn 0.4s ease forwards;\r\n    opacity: 0;\r\n}\r\n\r\n.info-card {\r\n    padding: 20px;\r\n    font-size: 1rem;\r\n    line-height: 1.5;\r\n    /*color: #333;*/\r\n    position: relative;\r\n    /*background: #fff8f5;*/\r\n    border-left: 4px solid #6fb8af;\r\n    border-radius: 0 0 14px 14px;\r\n    height: 250px;\r\n    overflow-y: auto;\r\n}\r\n\r\n/* Icône décorative en fond */\r\n.info-card::before {\r\n    content: \"💻\";\r\n    position: absolute;\r\n    font-size: 70px;\r\n    opacity: 0.15;\r\n    right: 20px;\r\n    bottom: 10px;\r\n    pointer-events: none;\r\n}\r\n\r\n/* Animation d’apparition du texte */\r\n.info-card p {\r\n    animation: fadeIn 0.4s ease forwards;\r\n    opacity: 0;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from { opacity: 0; transform: translateY(4px); }\r\n    to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n/* --- Bouton Refresh --- */\r\n\r\n.refresh-btn {\r\n    padding: 6px 12px;\r\n    background: #6fb8af;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: 0.2s ease;\r\n}\r\n\r\n.refresh-btn:hover {\r\n    background: #5aa79e;\r\n}\r\n\r\n.refresh-btn:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .refresh-btn {\r\n    background: #6fb8af;\r\n    color: #0a1929;\r\n}\r\n\r\n.dashboard.dark .refresh-btn:hover {\r\n    background: #5aa79e;\r\n}\r\n\r\n.pagination-controls {\r\n    position: absolute;\r\n    bottom: 15px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n}\r\n\r\n.pagination-controls button {\r\n    width: 35px;\r\n    height: 35px;\r\n\r\n    border: none;\r\n    border-radius: 50%;\r\n\r\n    background: rgba(104, 211, 206, 0.2);\r\n    color: #68d3ce;\r\n\r\n    cursor: pointer;\r\n    transition: 0.3s;\r\n}\r\n\r\n.pagination-controls button:hover {\r\n    background: #68d3ce;\r\n    color: #111;\r\n}\r\n\r\n.pagination-controls span {\r\n    color: #fff;\r\n    font-size: 14px;\r\n}\r\n\r\n.pagination-dots {\r\n    position: absolute;\r\n    bottom: 15px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n.dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    background: rgba(255,255,255,0.3);\r\n    cursor: pointer;\r\n    transition: 0.3s;\r\n}\r\n\r\n.dot.active {\r\n    background: #68d3ce;\r\n    transform: scale(1.2);\r\n}\r\n\r\n.info-content {\r\n    animation: fadeIn 0.5s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(15px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.pagination-container {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n\r\n    width: 200px;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.progress-bar {\r\n    width: 100%;\r\n    height: 4px;\r\n    background: rgba(255, 255, 255, 0.15);\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n}\r\n\r\n.progress-fill {\r\n    height: 100%;\r\n    background: #68d3ce;\r\n    border-radius: 10px;\r\n\r\n    animation: progressAnimation 10s linear forwards;\r\n}\r\n\r\n@keyframes progressAnimation {\r\n    from {\r\n        width: 0%;\r\n    }\r\n\r\n    to {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.segments {\r\n    display: flex;\r\n    gap: 4px;\r\n    width: 100%;\r\n}\r\n\r\n.segment {\r\n    display: flex;\r\n    gap: 6px;\r\n    width: 100%;\r\n    height: 6px;\r\n    background: rgba(255,255,255,.15);\r\n    border-radius: 20px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    cursor: pointer;\r\n}\r\n\r\n.segment.completed {\r\n    background: #68d3ce;\r\n}\r\n\r\n.segment-progress {\r\n    height: 100%;\r\n    background: linear-gradient(\r\n            90deg,\r\n            #68d3ce,\r\n            #8ef5f0\r\n    );\r\n}\r\n\r\n.timer-display {\r\n    margin-top: 6px;\r\n\r\n    text-align: center;\r\n    font-size: 12px;\r\n\r\n    color: rgba(255,255,255,0.6);\r\n}\r\n\r\n.announcement-footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n\r\n    width: 100%;\r\n    padding: 0 20px 10px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n/* Tablette */\r\n@media (max-width: 1024px) {\r\n    .cards {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n    .layout-two-cols {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n.menu-btn {\r\n    display: none;\r\n    font-size: 26px;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    margin-right: 12px;\r\n}\r\n\r\n\r\n/* Mobile */\r\n@media (max-width: 768px) {\r\n    .menu-btn {\r\n        display: block;\r\n    }\r\n    .dashboard {\r\n        flex-direction: column;\r\n    }\r\n    .content {\r\n        padding: 12px;\r\n    }\r\n    .cards {\r\n        grid-template-columns: 1fr;\r\n        gap: 12px;\r\n    }\r\n    .layout-two-cols {\r\n        gap: 12px;\r\n        margin-top: 20px;\r\n    }\r\n    .sidebar {\r\n        height: 100vh;\r\n        position: fixed;\r\n        left: 0;\r\n        top: 0;\r\n        transition: transform 0.3s ease;\r\n        z-index: 200;\r\n        transform: translateX(-100%);\r\n    }\r\n    .sidebar.open {\r\n        transform: translateX(0);\r\n    }\r\n    .server-status-group {\r\n        display: none;\r\n    }\r\n    .topbar {\r\n        padding: 12px 16px;\r\n        flex-direction: column;\r\n        align-items: stretch;\r\n        flex-wrap: wrap;\r\n    }\r\n    .topbar-left {\r\n        flex-wrap: wrap;\r\n        min-width: 0\r\n    }\r\n    .topbar-right {\r\n        display: none;\r\n    }\r\n\r\n    .search {\r\n        flex: none;\r\n        min-width: 120px;\r\n    }\r\n\r\n    .server-status-group,\r\n    .session-container,\r\n    .notif-wrapper,\r\n    .avatar-wrapper {\r\n        min-width: 0;\r\n        flex-shrink: 1; /* autorise la compression */\r\n    }\r\n\r\n    .badge {\r\n        white-space: nowrap; /* évite les retours moches */\r\n        font-size: 14px;\r\n    }\r\n    .sidebar-close-btn {\r\n        display: block;\r\n        background: none;\r\n        border: none;\r\n        font-size: 22px;\r\n        cursor: pointer;\r\n        color: #0b1f24;\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
